import Button from "@shared/components/button/Button";
import { IconButton } from "@shared/components/icon-button";
import { FC, useState } from "react";
import { ICON_SIZE, ICON_VARIANT } from "@shared/components/icon-button/types";
import CartIcon from "@svg/product/Cart";
import Bookmark from "@svg/new-design/bookmark";
import BookmarkBold from "@svg/new-design/bookmark-bold";
import { BUTTON_SIZE } from "@shared/components/button/types";
import { useAccess } from "@templates/course/hooks/useAccess";
import { useCartContext } from "@context/cart";
import { useRouter } from "next/router";
import { useAppContext } from "@context/app";
import { getUrlByCourseType } from "@utils/course";
import { useIsMobile } from "@shared/hooks/useIsMobile";
import classNames from "classnames";
import WhiteAddedCartIcon from "@svg/new-design/white-added-cart-icon";

const PublishedProductPageActions: FC = () => {
  const { courseData, setFavoriteAction, favoriteLoading } = useAccess();
  const {
    product: { is_free: isFree, id, sku },
    user: { is_favorite: isFavorite },
  } = courseData;
  const { addItem, registerFree, cart } = useCartContext();
  const { asPath, push, replace, query } = useRouter();
  const {
    user: { isLoggedIn },
  } = useAppContext();
  const isLessThanXLG = useIsMobile(1200);

  const [loading, setLoading] = useState(false);

  const startLearning = async () => {
    if (!isLoggedIn) {
      push("/register?next=" + encodeURIComponent(asPath));
      return;
    }
    setLoading(true);
    await registerFree(id);
    setLoading(false);
    const search = new URLSearchParams(location.search);
    if (query.registered !== "1") search.set("registered", "1");
    replace({
      pathname: getUrlByCourseType(
        courseData.product.attribute_type,
        courseData.product.webinar?.webinar_status,
        courseData.product.slug
      ),
      search: search.toString(),
    });
  };

  const addToCart = async () => {
    setLoading(true);
    await addItem({ id: id, sku: sku });
    setLoading(false);
  };

  const addFavorite = async () => {
    if (!favoriteLoading) await setFavoriteAction();
  };

  const isInCart =
    (cart || []).findIndex((ci) => ci.id === courseData.product?.id) !== -1;
  return (
    <>
      <Button
        startIcon={isInCart ? <WhiteAddedCartIcon /> : <CartIcon />}
        size={BUTTON_SIZE.XLARGE}
        onClick={
          isFree
            ? startLearning
            : isInCart
              ? () => push("/checkout")
              : addToCart
        }
        className="grow"
        disabled={loading}
      >
        {isFree
          ? "شروع یادگیری"
          : isInCart
            ? "پرداخت و شروع یادگیری"
            : isLessThanXLG
              ? "افزودن به سبد"
              : "افزودن به سبد سفارش"}
      </Button>
      <IconButton
        title={isFavorite ? "حذف از علاقه‌مندی" : "افزودن به علاقه‌مندی‌"}
        aria-label={isFavorite ? "حذف از علاقه‌مندی" : "افزودن به علاقه‌مندی‌"}
        disabled={favoriteLoading}
        onClick={addFavorite}
        size={ICON_SIZE.LARGE}
        variant={ICON_VARIANT.DEFAULT}
        className={classNames(
          "rounded-md border border-fds-brand text-fds-brand hover:bg-fds-brand-light",
          favoriteLoading && "!cursor-not-allowed"
        )}
        icon={
          isFavorite ? (
            <BookmarkBold width={22} height={22} />
          ) : (
            <Bookmark width={22} height={22} />
          )
        }
      />
    </>
  );
};

export default PublishedProductPageActions;
